/**
 * User: n.gorte
 * Date: 06.07.2022
 * Time: 13:39
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import '../../css/object-info.scss';
import { CartoObjectInfoItem } from './CartoObjectInfoItem';

export const ObjectInfoPreview = ({ layerConfigs, layers, latlng, metresPerPixel }) => {
    if (!layerConfigs || !layers || !latlng || !metresPerPixel) {
        return null;
    }
    layerConfigs = layerConfigs.filter(item => item.typeKey !== 'remote-data-layer' && item.typeKey !== 'remote-vector-layer');
    return (
        <ul className="list-group m-0">
            {
                layerConfigs && layerConfigs.map(layerConfig => {
                    const layer = layers && Object.keys(layers).reduce((acc, key) => {
                        const l = layers[ key ];
                        if (l.id === layerConfig.uuid || l.logicalLayerId === layerConfig.id) {
                            acc = layers[ key ];
                        }
                        return acc;
                    }, null);
                    const ObjectInfoItem = layer && layer.controller && layer.controller.getObjectInfoItem && layer.controller.getObjectInfoItem();

                    if (ObjectInfoItem) {
                        return (
                            <ObjectInfoItem
                                key={ layerConfig.id }
                                layerConfig={ layerConfig }
                                layer={ layer }
                            />
                        );
                    }

                    if (layerConfig.typeKey === 'cartodb') {
                        return (
                            <CartoObjectInfoItem
                                key={ layerConfig.id }
                                layerConfig={ layerConfig }
                                latlng={ latlng }
                                metresPerPixel={ metresPerPixel }
                            />
                        );
                    }
                    return (
                        <li className="list-group-item leaflet-object-info__item" key={ layerConfig.id }>
                            <span className="leaflet-object-info__item__title mb-2">{ layerConfig.title }</span>
                            <span className="leaflet-object-info__item__nodata">Keine weiteren Fachinformationen vorhanden.</span>
                        </li>
                    );
                })
            }
        </ul>
    );
};

ObjectInfoPreview.propTypes = {
    latlng: PropTypes.object,
    layerConfigs: PropTypes.arrayOf(PropTypes.object),
    layers: PropTypes.object,
    metresPerPixel: PropTypes.number,
};



// WEBPACK FOOTER //
// ./js/plugins/ExternalLayerFeatureClickPlugin/ObjectInfoPreview.jsx